import { useMemo } from 'react';
import { convertStyleProps } from './utils';
export function useStyleProps(props, handlers, ownStylesToMerge) {
  const style = useMemo(() => convertStyleProps(props, handlers), [props, handlers]);
  return useMemo(() => ({
    style: {
      ...ownStylesToMerge,
      ...style
    }
  }), [ownStylesToMerge, style]);
}